<template>
    <b-toast
        :id="id"
        solid
        no-close-button
        auto-hide-delay="1500"
        :toast-class="toastClass"
        :toaster="toastPosition"
    >
        <div
            class="toast__content"
            :class="{ toastContentMobile: isMobileDevice }"
        >
            <div class="toast__content__icon">
                <img
                    v-if="type === 'success'"
                    src="@/assets/images/toast/success.png"
                />
                <img
                    v-if="type === 'error'"
                    src="@/assets/images/toast/error.png"
                />
                <img
                    v-if="type === 'warning'"
                    src="@/assets/images/toast/warning.png"
                />
            </div>
            <div
                class="toast__content__title"
                :class="{
                    errorToast: type === 'error',
                    warningToast: type === 'warning',
                }"
            >
                {{ getTranslatedText(title) }}
            </div>
        </div>
    </b-toast>
</template>
<script>
import LanguageMixin from "@/mixins/language/language-mixin";
export default {
    mixins: [LanguageMixin],
    props: {
        title: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "my-toast",
        }
    },
    data() {
        return {
            isMobileDevice: false,
            toastPosition: "b-toaster-top-right",
            toastClass: "toast-custom",
        };
    },
    components: {},
    mounted() {
        this.checkDevice();
    },
    methods: {
        checkDevice() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                this.isMobileDevice = true;
                this.toastPosition = "b-toaster-bottom-full";
                this.toastClass = "toast-custom-mobile";
            } else {
                this.isMobileDevice = true;
                this.toastPosition = "b-toaster-bottom-right";
                this.toastClass = "toast-custom";
            }
        },
    },
};
</script>
<style scoped lang="scss" src="@/assets/scss/common/toast/toast.scss" />
